import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectNode } from '../state/nodeSlice';
import { useHistory } from 'react-router-dom';
import { APP_ROUTES } from '../App';
import { displayStepperSlice } from '../state/displayStepperSlice';
import { maintTitleSlice } from '../state/mainTitleSlice';
import { mainSubtitleSlice } from '../state/mainSubtitleSlice';
import { selectAccompanimentType } from '../state/accompanimentTypeSlice';
import { useAppDispatch } from '../utils/hooks';
import { hasErrorSlice } from '../state/hasErrorSlice';
import { AUTOMATIC, TC_EVENT_COMMON_DATA } from '../utils/consts';
import IPageTracking from '../interfaces/IPageTracking';
import { selectDeviceType } from '../state/deviceTypeSlice';
import { selectDeviceModel } from '../state/deviceModelSlice';
import { selectTree } from '../state/treeSlice';
import { pushTcClicEvent } from '../utils/tc-utils';

import problemeResoluImage from '../assets/images/solution-en-ligne.jpg';

export default function OKSolution(): React.ReactElement {
  const previousNode = useSelector(selectNode);
  const deviceType = useSelector(selectDeviceType);
  const accompanimentSelected = useSelector(selectAccompanimentType);
  const deviceModel = useSelector(selectDeviceModel);
  const treeSelected = useSelector(selectTree);
  const history = useHistory();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (AUTOMATIC !== accompanimentSelected && null === previousNode) {
      return history.push(APP_ROUTES.home);
    }
    dispatch(displayStepperSlice.actions.hide());
    dispatch(maintTitleSlice.actions.update('Super, votre problème est résolu !'));
    dispatch(mainSubtitleSlice.actions.update({
      desktop: 'Si vous avez d’autres questions, n’hésitez pas à consulter l’assistance ou l’application Bouygues Telecom',
      mobile: 'Si vous avez d’autres questions, n’hésitez pas à consulter l’assistance ou l’application Bouygues Telecom'
    }));
    dispatch(hasErrorSlice.actions.remove());
    const tcVars: IPageTracking = Object.assign({}, TC_EVENT_COMMON_DATA, { page: 'Confirmation', pageCategorie: 'Information', pageVariante: { diagnostic: AUTOMATIC === accompanimentSelected ? 'parcoursPicea' : 'parcoursDiagAutonome' }, variablesSpecifiques: { equipement: deviceType, marque: deviceModel?.brand.label, modele: deviceModel?.label, diagnostic: treeSelected?.name } });
    window.tc_vars = tcVars;
    tc_events_2(window, 'data-layer-ready', tcVars);
  }, [previousNode]);

  return (
    <>
      <section className="section has-background-white">
        <div className="container">
          <div className="columns is-centered">
            <div className="column is-9-widescreen is-11-tablet">
              <div className="buttons is-centered">
                <a className="button is-secondary" href="https://www.assistance.bouyguestelecom.fr/s/" onClick={() => pushTcClicEvent('Consulter_assistance')}>Consulter l’assistance</a>
                <a className="button is-secondary" href="https://3fzy.adj.st/im?adj_t=rcxb7az&adj_campaign=DIGITAL_beety_app_dans_diag_mobile&adj_adgroup=AUTRES&adj_creative=0&utm_medium=AUTRES_nc&utm_source=adj202412&utm_campaign=DIGITAL_beety_app_dans_diag_mobile" onClick={() => pushTcClicEvent('Ouvrir_application_bouygues_telecom')}>Ouvrir l’application Bouygues Telecom</a>
              </div>
            </div>
          </div>
          <div className="columns is-centered">
            <div className="column is-7-widescreen is-11-tablet">
              <div className="card">
                <figure className="image">
                  <img className="has-border-radius-large is-bordered is-fullwidth" src={problemeResoluImage} alt="Solution en ligne" loading="lazy"/>
                </figure>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
